import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface PendingItem {
  doc_no: string;
  receive_date: string | null;
  vendor_code: string;
  vendor_name: string;
  dept_code: string;
  dept_name: string;
  status: string;
  version_count: number;
  default_checked: boolean;
}

export interface PendingResponse {
  items: PendingItem[];
  total: number;
}

export interface ReverseResultItem {
  doc_no: string;
  success: boolean;
  message: string;
}

export interface ReverseResponse {
  results: ReverseResultItem[];
  success: number;
  failed: number;
  message: string;
}

export interface ReversalFilter {
  docStart: string;
  docEnd: string;
}

// ============================================================
// API methods
// ============================================================

export const r5d2Api = {
  // GET /api/r5d2/pending?docStart=&docEnd=
  async getPending(filter: ReversalFilter): Promise<PendingResponse> {
    const res = await apiClient.get('/api/r5d2/pending', {
      params: {
        docStart: filter.docStart,
        docEnd: filter.docEnd,
      },
    });
    return res.data;
  },

  // POST /api/r5d2/reverse
  async reverse(docNos: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/r5d2/reverse', { doc_nos: docNos });
    return res.data;
  },
};
